import { render, staticRenderFns } from "./VStakeholderColumnsManager.vue?vue&type=template&id=71be74d0&scoped=true&"
import script from "./VStakeholderColumnsManager.vue?vue&type=script&lang=js&"
export * from "./VStakeholderColumnsManager.vue?vue&type=script&lang=js&"
import style0 from "./VStakeholderColumnsManager.vue?vue&type=style&index=0&id=71be74d0&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "71be74d0",
  null
  
)

export default component.exports